<section class="duna-directory-list">
  <header class="list-header">
    <div class="list-title">
      <mat-icon>groups</mat-icon>
      <h2>Alle brugere</h2>
      @if (totalCount || displayedRows.length) {
      <span class="list-count">{{ getCountLabel() }}</span>
      }
    </div>
    <mat-form-field
      appearance="outline"
      class="list-search"
      subscriptSizing="dynamic"
    >
      <mat-label>Søg navn, lokation, uddannelsesvej eller DUNA-status</mat-label>
      <input
        matInput
        [ngModel]="userSearch"
        (ngModelChange)="onUserSearchChange($event)"
      />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </header>

  @if (loading) {
  <mat-progress-bar mode="indeterminate" class="list-progress"></mat-progress-bar>
  }

  @if (loadError) {
  <p class="list-empty list-empty--error">{{ loadError }}</p>
  }

  @if (!loadError && displayedRows.length) {
  <div class="directory" role="list">
    <div class="directory-header">
      <span class="directory-header-avatar"></span>
      <button
        type="button"
        class="directory-header-sort directory-header-identity"
        (click)="onSortHeaderClick('identity', $event)"
      >
        Navn
        <mat-icon class="sort-icon">{{ sortIcon('identity') }}</mat-icon>
      </button>
      <button
        type="button"
        class="directory-header-sort directory-header-meta"
        (click)="onSortHeaderClick('meta', $event)"
      >
        Uddannelse
        <mat-icon class="sort-icon">{{ sortIcon('meta') }}</mat-icon>
      </button>
      <button
        type="button"
        class="directory-header-sort directory-header-stamp"
        (click)="onSortHeaderClick('stamp', $event)"
      >
        DUNA
        <mat-icon class="sort-icon">{{ sortIcon('stamp') }}</mat-icon>
      </button>
      <button
        type="button"
        class="directory-header-sort directory-header-progress"
        (click)="onSortHeaderClick('progress', $event)"
      >
        Fremgang
        <mat-icon class="sort-icon">{{ sortIcon('progress') }}</mat-icon>
      </button>
      <span class="directory-header-action"></span>
    </div>
    @for (row of displayedRows; track row.uuid) {
    <div
      class="directory-row"
      role="listitem"
      (click)="onUserRowClick(row)"
    >
      <app-duna-profile-image
        [obfuscatedName]="row.profileImageObfuscatedName"
        [fallbackInitials]="row.initials"
        [size]="40"
        [canEdit]="false"
        [scopeType]="'user'"
        [scopeId]="row.userId"
        [entityUuid]="row.uuid"
        [entityKind]="'user'"
      ></app-duna-profile-image>
      <div class="row-identity">
        <span class="row-name"
          >{{ row.user.first_name }} {{ row.user.last_name }}</span
        >
        <span class="row-subtitle">{{ row.primaryLocation }}</span>
      </div>
      <div class="row-meta">
        <app-duna-educational-path-badge
          [educationalPaths]="row.educationalPaths"
          [currentYear]="currentYear"
          [showStatus]="true"
        ></app-duna-educational-path-badge>
      </div>
      <div class="row-stamp">
        @if (row.validationStatus; as status) {
        <app-duna-validation-badge
          [status]="status"
          [isDetailBadge]="true"
        ></app-duna-validation-badge>
        }
      </div>
      <div class="row-progress">
        <app-duna-user-progress-label
          [registeredPercentage]="row.progressLabel.registeredPercentage"
          [progressPercentage]="row.progressLabel.progressPercentage"
          [paths]="row.progressLabel.paths"
          [totals]="row.progressLabel.totals"
          [year]="currentYear"
          (click)="$event.stopPropagation()"
        ></app-duna-user-progress-label>
      </div>
      <mat-icon class="row-chevron">chevron_right</mat-icon>
    </div>
    }
  </div>
  } @else if (!loading && !loadError) {
  <p class="list-empty">
    {{
      userSearch
        ? 'Ingen brugere matcher søgningen'
        : 'Ingen brugere fundet'
    }}
  </p>
  }

  <mat-paginator
    [length]="totalCount"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onPageChange($event)"
    aria-label="Vælg side"
  ></mat-paginator>
</section>
